import { NextPage } from "next"
import { Seo } from "../components/seo"
import React from "react"

const TermOfServicesPage: NextPage = () => {
  return (
    <div className={"container my-16 mx-auto"}>
      <Seo title="Termini e Condizioni" />
      <article className="prose lg:prose-xl">
        <br />
        <p>
          <strong>Termini e Condizioni</strong>
        </p>
        <p>
          Il presente documento riporta i termini e le condizioni generali sulla
          base dei quali viene offerto agli utenti l&apos;uso del sito web
          www.arezzomedia.com che offre il download di contenuti multimediali,
          quali ad esempio immagini e video, della città di Arezzo e Provincia.
        </p>
        <p>
          1. <strong>Definizioni</strong>
        </p>
        <p>
          Per consentire una completa comprensione e accettazione dei presenti
          termini e condizioni, i seguenti termini, al singolare e al plurale,
          avranno il significato di seguito indicato:
        </p>
        <p>
          <strong>Titolare: Fondazione Arezzointour</strong>, con sede legale in
          Via Albergotti 13, 52100, Arezzo, Partita IVA / Codice Fiscale
          92089510512
        </p>
        <p>
          <strong>Applicazione: </strong>
          il sito web www.arezzomedia.com
        </p>
        <p>
          <strong>Prodotti: </strong>i contenuti multimediali forniti all’utente
          dal Titolare o forniti tramite l’Applicazione da un fornitore terzo.
        </p>
        <p>
          <strong>Utente: </strong>
          qualunque soggetto che accede e utilizza l’Applicazione
        </p>
        <p>
          <strong>Contenuto multimediale: </strong>
          fotografie in fomato jpg (o jpeg), video in formato mp4, elaborazioni
          grafiche in formato pdf
        </p>
        <p>
          <strong>Contenuti: </strong>
          qualsiasi elemento testuale o multimediale presente sull’Applicazione,
          a titolo di esempio annunci, inserzioni, recensioni, immagini, etc.
        </p>
        <p>
          <strong>Condizioni: </strong>
          il presente contratto che disciplina i rapporti tra il Titolare e gli
          Utenti e la vendita o fornitura dei Prodotti offerti dal Titolare
          tramite l’Applicazione.
        </p>
        <p>
          2. <strong>Rapporti tra Titolare, Fornitore Terzo e Utenti</strong>
        </p>
        <p>
          L’Applicazione ospita una piattaforma gestita dal Titolare che
          consente di mettere in contatto Utenti interessati ai Prodotti offerti
          dal Titolare.
        </p>
        <p>
          Sull’Applicazione, gli Utenti possono scaricare a titolo gratuito il
          contenuto.
          <s></s>
        </p>
        <p>
          3. <strong>Ambito di applicazione delle Condizioni</strong>
        </p>
        <p>
          L’uso dell’Applicazione comporta l’accettazione delle Condizioni da
          parte dell’Utente e il rispetto delle condizioni della licenza
          <a href="https://creativecommons.org/licenses/by-nc-nd/4.0/deed.it">
            Creative Common
          </a>
          <u> CC BY-NC-ND 4.0</u>. Qualora l’Utente non intenda accettare le
          Condizioni e/o qualsiasi altra nota, avviso legale, informativa
          pubblicati o ivi richiamati non potrà utilizzare l’Applicazione né i
          relativi servizi tra i quali il download dei contenuti multimediali.
        </p>
        <p>Le Condizioni possono essere modificate in ogni momento.</p>
        <p>
          Le Condizioni applicabili sono quelle in vigore alla data di
          scaricamento del materiale multimediale .
        </p>
        <p>
          Prima di utilizzare l’Applicazione, l’Utente è tenuto a leggere
          attentamente le Condizioni e a salvarle o stamparle per future
          consultazioni.
        </p>
        <p>
          Il Titolare si riserva il diritto di variare a propria discrezione, in
          qualunque momento anche successivo alla registrazione dell’Utente,
          l’interfaccia grafica dell’Applicazione, i Contenuti e la loro
          organizzazione, nonché ogni altro aspetto che caratterizza la
          funzionalità e la gestione dell’Applicazione, comunicando all’Utente,
          ove occorrenti, le relative istruzioni.
        </p>
        <p>
          4. <strong>Utilizzo del materiale multimediale</strong>
        </p>
        <p>
          Tutto il materiale multimediale offerto tramite l’Applicazione è
          descritto in maniera dettagliata nelle relative pagine.<sub></sub>
        </p>
        <p>
          5. <strong>Registrazione</strong>
        </p>
        <p>
          Per usufruire delle funzionalità dell’Applicazione, gli Utenti devono
          registrarsi fornendo, in maniera veritiera e completa, tutti i dati
          richiesti nel relativo form di registrazione ed accettare
          integralmente la privacy policy (
          <a href="http://www.arezzomedia.com/privacy-policy">
            www.arezzomedia.com/privacy-policy
          </a>
          ) e le presenti Condizioni di utilizzo.
        </p>
        <p>
          L’Utente ha l’onere di custodire le proprie credenziali di accesso che
          devono essere utilizzate esclusivamente dall’Utente e non possono
          essere cedute a terzi. L’Utente si impegna a tenerle segrete e ad
          assicurarsi che nessun terzo vi abbia accesso e a informare
          immediatamente il Titolare nel caso in cui sospetti o venga a
          conoscenza di un uso indebito o di una indebita divulgazione delle
          stesse.
        </p>
        <p>
          L&apos;Utente garantisce che le informazioni personali fornite durante
          la procedura di registrazione sono complete e veritiere e si impegna a
          tenere il Titolare indenne e manlevato da qualsiasi danno, obbligo
          risarcitorio e/o sanzione derivante da e/o in qualsiasi modo collegata
          alla violazione da parte dell&apos;Utente delle regole sulla
          registrazione all’Applicazione o sulla conservazione delle credenziali
          di registrazione.
        </p>
        <p>
          6. <strong>Cancellazione account e chiusura</strong>
        </p>
        <p>
          L’Utente registrato può interrompere l’utilizzo dell’Applicazione in
          ogni momento e disattivare il proprio account o richiederne la
          cancellazione attraverso l’interfaccia dell’Applicazione, se
          possibile, o inviando una comunicazione scritta all’indirizzo e-mail
          <a href="mailto:arezzomedia@arezzointour.it">
            arezzomedia@arezzointour.it
          </a>
          .
        </p>
        <p>
          In caso di violazione da parte dell’Utente delle Condizioni o delle
          disposizioni di legge applicabili, il Titolare si riserva il diritto
          di sospendere o chiudere l’account dell’Utente in ogni momento e senza
          preavviso.
        </p>
        <p>
          7. <strong>Modalità di fornitura di Prodotti digitali</strong>
        </p>
        <p>
          Il Titolare provvederà a caricare il materiale multimediale che
          l’Utente potrà consultare e scaricare alle presenti condizioni di
          utilizzo.
          <s></s>
        </p>
        <p>
          8.<strong> Contenuti Multimediali </strong>e{" "}
          <strong>Licenza d’uso</strong>
        </p>
        <p>
          Arezzomedia ti permette di cercare, visualizzare e scaricare immagini
          o video che riproducono la Città di Arezzo e la sua Provincia. Puoi
          scaricare il contenuto multimediale in accordo con la Licenza d’uso
          <a href="https://creativecommons.org/licenses/by-nc-nd/4.0/deed.it">
            Creative Common
          </a>
          <u> CC BY-NC-ND 4.0</u>, nel rispetto delle relative clausole di
          attribuzione.
          <s></s>
        </p>
        <p>
          La licenza non permette di scaricare i contenuti per replicare un
          servizio competitivo o simile a quello di Arezzomedia. Non è possibile
          distribuire o vendere i contenuti presenti su{" "}
          <a href="http://www.arezzomedia.com">www.arezzomedia.com</a> in altre
          piattaforme o siti simili.
        </p>
        <p>
          L’utilizzo è gratuito, ma non è possibile utilizzare i contenuti per
          promuovere luoghi, città, territori diversi da quelli rappresentati.
        </p>
        <p>
          Il diritto di utilizzo non comprende il diritto ad utilizzare
          eventuali loghi, trademarks, brand, persone riconoscibili, opere
          d’arte rappresentate. Potreste dover chiedere il permesso di
          utilizzare questi elementi ai diretti proprietari.
        </p>
        <p>
          I contenuti scaricabili non possono essere utilizzati per promuovere
          e/o essere accostati a materiale illegale, pericoloso, minatorio,
          offensivo, illecito, diffamatorio, calunnioso, volgare, osceno,
          blasfemo, lesivo della privacy altrui o istigante all’odio.
        </p>
        <p>
          La Fondazione Arezzo Intour si riserva il diritto di modificare i
          termini e le condizione delle licenze dei prodotti in qualsiasi
          momento, si precisa che il materiale scaricato in precedenza manterrà
          le licenze come al momento del download.
        </p>
        <p>
          9. <strong>Esclusione della garanzia</strong>
        </p>
        <p>
          L’Applicazione viene fornita ”così come è” e ”come è disponibile” e il
          Titolare non fornisce alcuna garanzia esplicita o implicita in
          relazione all’Applicazione, né fornisce alcuna garanzia che
          l’Applicazione potrà soddisfare le esigenze degli Utenti o che non
          avrà mai interruzioni o sarà priva di errori o che sarà priva di virus
          o bug.
        </p>
        <p>
          Il Titolare si adopererà per assicurare che l’Applicazione sia
          disponibile ininterrottamente 24 ore al giorno, ma non potrà in alcun
          modo essere ritenuto responsabile se, per qualsiasi motivo,
          l’Applicazione non fosse accessibile e/o operativa in qualsiasi
          momento o per qualsiasi periodo. L’accesso all’Applicazione può essere
          sospeso temporaneamente e senza preavviso in caso di guasto del
          sistema, manutenzione, riparazioni o per ragioni del tutto estranee
          alla volontà del Titolare o per eventi di forza maggiore.
        </p>
        <p>
          10. <strong>Limitazione della Responsabilità</strong>
        </p>
        <p>
          Il Titolare non potrà ritenersi responsabile verso l’Utente per
          disservizi o malfunzionamenti connessi all’utilizzo della rete
          internet al di fuori del controllo proprio o di suoi fornitori.
        </p>
        <p>
          Il Titolare non sarà inoltre responsabile in merito a danni, perdite e
          costi subiti dall’Utente a seguito della mancata esecuzione del
          contratto per cause a lui non imputabili.
          <s></s>
        </p>
        <p>Il Titolare non sarà responsabile per:</p>
        <p>
          ● eventuali perdite di opportunità commerciale e qualsiasi altra
          perdita, anche indiretta, eventualmente subita dall’Utente che non
          siano conseguenza diretta della violazione del contratto da parte del
          Titolare
        </p>
        <p>
          ● errato o inidoneo utilizzo dell’Applicazione da parte degli Utenti o
          di terzi
        </p>
        <p>
          <s></s>
        </p>
        <p>
          11. <strong>Forza maggiore</strong>
        </p>
        <p>
          Il Titolare non potrà essere considerato responsabile per il mancato o
          ritardato adempimento delle proprie obbligazioni, per circostanze al
          di fuori del controllo ragionevole del Titolare dovuti ad eventi di
          forza maggiore o, comunque, ad eventi imprevisti ed imprevedibili e,
          comunque, indipendenti dalla sua volontà.
        </p>
        <p>
          L’adempimento delle obbligazioni da parte del Titolare si intenderà
          sospeso per il periodo in cui si verificano eventi di forza maggiore.
        </p>
        <p>
          Il Titolare compirà qualsiasi atto in suo potere al fine di
          individuare soluzioni che consentano il corretto adempimento delle
          proprie obbligazioni nonostante la persistenza di eventi di forza
          maggiore.
        </p>
        <p>
          12. <strong>Collegamento a siti di terzi</strong>
        </p>
        <p>
          L’Applicazione potrebbe contenere collegamenti a siti/applicazioni di
          terzi. Il Titolare non esercita alcun controllo su di essi e,
          pertanto, non è in alcun modo responsabile per i contenuti di questi
          siti/applicazioni.
        </p>
        <p>
          Alcuni di questi collegamenti potrebbero rinviare a siti/applicazioni
          di terzi che forniscono servizi attraverso l’Applicazione. In questi
          casi, ai singoli servizi si applicheranno le condizioni generali per
          l’uso del sito/applicazione e per la fruizione del servizio
          predisposte dai terzi, rispetto alle quali il Titolare non assume
          alcuna responsabilità.
        </p>
        <p>
          13. <strong>Privacy</strong>
        </p>
        <p>
          La tutela e il trattamento dei dati personali avverranno in conformità
          all’Informativa Privacy, che può essere consultata alla pagina
          www.arezzomedia.com/privacy-policy
        </p>
        <p>
          14. <strong>Legge applicabile e foro competente</strong>
        </p>
        <p>Le Condizioni sono soggette alla legge italiana.</p>
        <p>
          Per ogni controversia derivante dall’esecuzione, interpretazione e
          risoluzione del presente contratto, non diversamente conciliabile, le
          parti riconoscono fin da ora la competenza esclusiva del Tribunale di
          Arezzo, anche in ipotesi di connessione e continenza di cause.
        </p>
      </article>
    </div>
  )
}

export default TermOfServicesPage
